export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7087.258de6a6.jpg";